export const path = {
  financialReports: {
    route: "/financial-managements/financial-reports",
    link: () => path.financialReports.route,
  },
};
